import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PageRootWrapper from '../../components/common/PageRoot/PageRootWrapper';
import CompanyStatsContainer from '../../components/CompanyStats/CompanyStatsContainer';

const CompanyStats = ({ location }) => (
    <PageRootWrapper location={location}>
        <CompanyStatsContainer />
    </PageRootWrapper>
);

CompanyStats.propTypes = {
    location: ReactRouterPropTypes.location.isRequired,
};

export default CompanyStats;
